import { render, staticRenderFns } from "./PageLegalDetail.vue?vue&type=template&id=7ebb1c15&"
import script from "./PageLegalDetail.vue?vue&type=script&lang=js&"
export * from "./PageLegalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebb1c15')) {
      api.createRecord('7ebb1c15', component.options)
    } else {
      api.reload('7ebb1c15', component.options)
    }
    module.hot.accept("./PageLegalDetail.vue?vue&type=template&id=7ebb1c15&", function () {
      api.rerender('7ebb1c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/legal-detail/PageLegalDetail.vue"
export default component.exports